import { Flex, Panel, P, Text, utils, toast, PageLoading} from '@galilee/lilee';
import Layout from 'components/Layout';
import HomeHeader from 'components/HomeHeader';
import { useTrackNTrace } from 'state/track/TrackNTraceProvider';
import styled from 'styled-components';
import { useState, useEffect } from 'react';

const { useScrollToTop } = utils;

const StyledLink = styled.a`
    font-size: ${(p) => p.theme.fontSizes[0]};
    color: ${(p) => p.theme.colors.link};
`;

export const UnmarginedPanel = styled(Panel)`
    margin-bottom: 0;
    max-width: 100%;
    padding: 24px;
`;

export const StyledSubtitle = styled(Panel.Subtitle)`
    color: ${(p) => p.theme.colors.tertiary};
    text-transform: none;
    font-size: ${(p) => p.theme.fontSizes[1]};
`;

export const ItemTitle = styled(Text)`
    text-transform: uppercase;
    font-weight: ${(p) => p.theme.fontWeights.bold} !important;
    color: ${(p) => p.theme.colors.base40} !important;
    font-size: 12px !important;
`;

const DocumentContainer = styled(Flex)`
    flex-direction: row;
    justify-content: space-between;
    @media screen and (max-width: ${(p) => p.theme.breakpointsMax[1]}) {
        flex-direction: column;
    }
`;

const BackToTopP = styled(P)`
    cursor: pointer;    
    text-decoration: underline;   
    padding-top: 20px; 
    @media screen and (max-width: ${(p) => p.theme.breakpointsPlus[2]}) {
        display: block;
    }
`;

export const BackToTopLink = () => {
    const { setScrollToTop } = useScrollToTop(true);
    const handleClick = () => {
        const url = new URL(window.location);
        url.searchParams.delete('focus');
        window.history.pushState({},'', url);
        setScrollToTop(true);
    }

    return (
      <BackToTopP color="base40" onClick={handleClick}>        
          Back to top
      </BackToTopP>);
}

const DischargeForms = () => {
    const [isDownloading, setIsDownloading ] = useState(false);        
    const {actions: { getDischargeFormList, downloadDischargeForm }} = useTrackNTrace();       
    const [dischargeFormList, setDischargeFormList] = useState(undefined);  
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async (fileName) => {
        if(isDownloading) return;
        try {
            if(fileName === "") return;            
            setIsDownloading(true);
            await downloadDischargeForm(fileName);
       
        } catch {
            toast.error('Failed to download the discharge form.');
        } finally {
            setIsDownloading(false);
        }
    };

    useEffect(() => {
      async function fetchDischargeFormList() {
          setIsLoading(true);
          try {                                       
              const { dischargeFormList } = await getDischargeFormList();                    
              setDischargeFormList(dischargeFormList);                    
              if (!dischargeFormList) {
                  toast.error(`Discharge Form List does not exist.`);
                  return;
              }                    
          } catch (err) {
              toast.error(`Failed to get discharge form list`);
          }
          finally{
            setIsLoading(false);
          }
      }                   
        
      if (dischargeFormList) return;
      fetchDischargeFormList();
    }, [dischargeFormList]);

    return (
      <>
       {isLoading && <PageLoading backgroundColor="baseOpacity60" />}
        <Layout header={<HomeHeader title="Discharge Forms" showBreadcrumbs />}>
          <UnmarginedPanel id="dischargeForms">
              <Flex justifyContent="space-between">
                  <StyledSubtitle>Discharge Form Name</StyledSubtitle>                  
              </Flex>
              <Flex flexDirection="column">
                  {dischargeFormList?.map((filename, index) => (
                      <DocumentContainer key={index} mt="4">
                        <StyledLink href={filename} rel="noreferrer" onClick={(e) => {
                          e.preventDefault();
                          handleClick(filename)
                        }}>
                              {filename}
                          </StyledLink>                        
                      </DocumentContainer>
                  ))}                   
              </Flex>   
              <BackToTopLink />         
          </UnmarginedPanel>                        
        </Layout>
        </>      
    );
};

export default DischargeForms;
